<template>
	<div id="uCCollect">
		<div class="uCPageTop">
			<div class="uCPageTopTitle">
				<Icon type="ios-alert-outline" size="30" />
				<span> 已购视频</span>
			</div>
		</div>
		<div class="uCCollectList">
			<uVList></uVList>
			<ucPage :pageTotal="pagetotal" @clickPage="pageChange"></ucPage>
		</div>
	</div>
</template>

<script>
	import uVList from '../../components/user/uVideoList.vue';
	import ucPage from '../../components/content/page.vue';
	export default {
		name: 'uCCollect',
		components: {
			uVList,
			ucPage
		},
		data() {
			return {
				pagetotal: 20,
			}
		},
		methods: {
			pageChange(data) {
				console.log(data)
			}
		},
	}
</script>

<style>
	.uCCollectRadio {
		text-align: center;
		padding: 10px;
	}

	.uCCollectList {
		padding-top: 20px;
	}

	
</style>
